@let s = homeState();
@let home = s.kind === 'ok' ? s.home : undefined;

<!-- Announcement bar -->
<div class="h1-announcement">
  <div class="h1-announcement__inner">
    @if (announcement(home)?.pill; as pill) {
      <span class="h1-announcement__pill">{{ pill }}</span>
    } @else {
      <span class="h1-announcement__pill">Limited Slots</span>
    }
    <span class="h1-announcement__text">
      @if (announcement(home)?.text; as text) {
        {{ text }}
      } @else {
        Free counseling for September 2026 intake · <strong>Book before slots fill up</strong>
      }
    </span>
    <button type="button" class="h1-announcement__cta" (click)="scrollToForm()">
      {{ announcement(home)?.ctaLabel?.trim() || 'Apply now' }}
      <span aria-hidden="true">→</span>
    </button>
  </div>
</div>

<!-- Header -->
<header class="h1-header lf-header">
  <div class="h1-header__inner">
    <a routerLink="/" class="h1-logo">
      <span class="h1-logo__img-frame">
        <img class="h1-logo__img" src="/assets/images/logo.webp" alt="CareerGrad Global" width="200" height="52" />
      </span>
      <span class="h1-logo__wordmark">CareerGrad Global</span>
    </a>

    <div class="lf-header__trust">
      <span class="lf-header__rating">★ 4.9/5</span>
      <span class="lf-header__divider">|</span>
      <span>{{ stats(home)[0]?.value || '12K+' }} students placed</span>
    </div>
  </div>
</header>

<!-- Hero with form above the fold -->
<section class="lf-hero" id="lead-form">
  <div class="lf-hero__bg" aria-hidden="true"></div>
  <div class="lf-hero__inner">
    <div class="lf-hero__copy">
      <span class="h1-badge">
        <span class="h1-badge__dot"></span>
        {{ heroBadge(home) }}
      </span>
      <h1 class="lf-hero__title">
        Start Your <span class="lf-hero__highlight">Global Education</span> Journey Today
      </h1>
      <p class="lf-hero__lede">
        Get personalized study abroad counseling from India's most trusted consultants.
        University shortlisting, visa support, scholarships & loans — all in one place.
      </p>

      <ul class="lf-hero__features">
        @for (feature of heroFeatures(home); track feature) {
          <li>
            <span class="lf-hero__check" aria-hidden="true">✓</span>
            {{ feature }}
          </li>
        }
      </ul>

      <div class="lf-hero__badges">
        @for (badge of stats(home); track badge.label) {
          <div class="lf-hero__badge">
            <strong>{{ badge.value }}</strong>
            <span>{{ badge.label }}</span>
          </div>
        }
      </div>
    </div>

    <div class="lf-hero__form-wrap">
      <app-lead-capture-form sourcePage="/lead-form" />
    </div>
  </div>
</section>

<!-- Stats strip -->
<section class="h1-stats lf-stats">
  <div class="h1-stats__card">
    @for (stat of stats(home); track stat.label) {
      <div class="h1-stat">
        <div class="h1-stat__value">{{ stat.value }}</div>
        <div class="h1-stat__label">{{ stat.label }}</div>
      </div>
    }
  </div>
</section>

<!-- Why Choose -->
<app-marketing-why-choose />

<!-- Study Destinations -->
<section class="h1-section h1-section--cool" id="destinations">
  <div class="h1-section__inner">
    <header class="h1-section__head h1-section__head--center">
      <h2>{{ destinationsTitle(home) }}</h2>
      <p>{{ destinationsSubtitle(home) }}</p>
    </header>

    @if (destinations(home).length) {
      <div class="h1-dest-grid lf-dest-grid">
        @for (d of destinations(home); track d.slug) {
          <button type="button" class="h1-dest-card lf-dest-card" (click)="scrollToForm()">
            <div class="h1-dest-card__media" [style.background-image]="destinationBackground(d)"></div>
            <div class="h1-dest-card__overlay"></div>
            <div class="h1-dest-card__body">
              @if (d.flagIcon) {
                <span class="h1-dest-card__flag">{{ d.flagIcon }}</span>
              }
              <div class="h1-dest-card__name">{{ d.name }}</div>
              <div class="h1-dest-card__meta">{{ destinationMeta(d) }}</div>
            </div>
          </button>
        }
      </div>
    } @else if (s.kind !== 'pending') {
      <p class="lf-empty-note">Featured destinations will appear here once configured in admin.</p>
    }
  </div>
</section>

<!-- Our Services -->
<section class="h1-section" id="services">
  <div class="h1-section__inner">
    <header class="h1-section__head h1-section__head--center">
      <h2>Our Services</h2>
      <p>End-to-end support from your first counseling call to landing on campus abroad.</p>
    </header>

    <div class="lf-services-grid">
      @for (service of services; track service.title) {
        <article class="lf-service-card">
          <div class="lf-service-card__icon" aria-hidden="true">{{ service.icon }}</div>
          <h3>{{ service.title }}</h3>
          <p>{{ service.description }}</p>
        </article>
      }
    </div>
  </div>
</section>

<!-- Application Process Timeline -->
<app-marketing-success-roadmap />

<!-- Success Stories + Testimonials (CMS) -->
@if (home && (successStoryItems(home).length || testimonialItems(home).length)) {
  <section class="h1-section h1-section--warm" id="success-stories">
    <div class="h1-section__inner">
      @if (testimonialItems(home).length) {
        <header class="h1-section__head h1-section__head--center">
          <h2>What Our Students Say</h2>
          <p>Real stories from students who achieved their study abroad dreams with CareerGrad Global.</p>
        </header>
        <app-marketing-testimonials [items]="testimonialItems(home)" />
      }

      @if (successStoryItems(home).length) {
        <header class="h1-section__head h1-section__head--center" [class.lf-section-head--spaced]="testimonialItems(home).length">
          <h2>{{ successStoriesTitle(home) }}</h2>
          <p>{{ successStoriesSubtitle(home) }}</p>
        </header>
        <app-marketing-global-success-stories [stories]="successStoryItems(home)" />
      }
    </div>
  </section>
}

<!-- University Partners -->
@if (partners(home).length) {
  <section class="h1-section h1-section--dark" id="partners">
    <div class="h1-section__inner">
      <header class="h1-section__head h1-section__head--center">
        <h2>{{ partnersTitle(home) }}</h2>
        <p>Direct partnerships with globally ranked universities and institutions.</p>
      </header>

      <div class="lf-partners">
        @for (partner of partners(home); track partner.name) {
          <div class="lf-partner-badge">{{ partner.name }}</div>
        }
      </div>
    </div>
  </section>
}

<!-- FAQs -->
<section class="h1-section" id="faqs">
  <div class="h1-section__inner lf-faq-wrap">
    <header class="h1-section__head">
      <h2>Frequently Asked Questions</h2>
      <p>Everything you need to know before starting your study abroad journey.</p>
    </header>

    <div class="lf-faq-list">
      @for (faq of faqs; track faq.question; let i = $index) {
        <div class="lf-faq-item" [class.lf-faq-item--open]="openFaq() === i">
          <button type="button" class="lf-faq-item__trigger" (click)="toggleFaq(i)" [attr.aria-expanded]="openFaq() === i">
            <span>{{ faq.question }}</span>
            <span class="lf-faq-item__icon" aria-hidden="true">{{ openFaq() === i ? '−' : '+' }}</span>
          </button>
          @if (openFaq() === i) {
            <div class="lf-faq-item__answer">
              <p>{{ faq.answer }}</p>
            </div>
          }
        </div>
      }
    </div>
  </div>
</section>

<!-- Final CTA -->
<section class="h1-cta lf-final-cta">
  <div class="h1-cta__inner">
    <div class="h1-cta__copy">
      <span class="h1-eyebrow h1-eyebrow--on-dark">Your future starts now</span>
      <h2>
        Ready to Study <span class="h1-cta__highlight">Abroad?</span>
      </h2>
      <p>
        Join {{ stats(home)[0]?.value || '12,000+' }} students who trusted CareerGrad Global for their international education journey.
        Free counseling · No obligation · Expert guidance every step of the way.
      </p>
      <ul class="h1-cta__bullets">
        <li><span aria-hidden="true">✓</span> Free 45-minute consultation</li>
        <li><span aria-hidden="true">✓</span> University shortlist within a week</li>
        <li><span aria-hidden="true">✓</span> Scholarship & loan support included</li>
      </ul>
    </div>

    <div class="lf-hero__form-wrap">
      <app-lead-capture-form sourcePage="/lead-form" [compact]="true" />
    </div>
  </div>
</section>

<!-- Footer -->
<footer class="lf-footer">
  <div class="lf-footer__inner">
    <div class="lf-footer__brand">
      <img src="/assets/images/logo.webp" alt="CareerGrad Global" width="160" height="42" />
      <p>India's trusted study abroad consultants. Personalized guidance for your global education journey.</p>
    </div>
    <div class="lf-footer__links">
      <a href="https://careergradglobal.com" target="_blank" rel="noopener">careergradglobal.com</a>
      <a href="tel:+919876543210">+91 98765 43210</a>
      <a href="mailto:info@careergradglobal.com">info@careergradglobal.com</a>
    </div>
    <p class="lf-footer__copy">© {{ 2026 }} CareerGrad Global. All rights reserved.</p>
  </div>
</footer>

<!-- Sticky mobile CTA -->
<div class="lf-sticky-cta" aria-label="Quick apply">
  <button type="button" class="h1-btn h1-btn--accent h1-btn--block" (click)="scrollToForm()">
    Get Free Counseling →
  </button>
</div>
